import styled from 'styled-components';

export const BodyStyled = styled.div`
  height: 100%;
  background-color: #fff;
  border-radius: 12px;
  /* background-color: brown; */
  /* border-radius: 0 0 5px 5px; */

  .contentBox {
    height: calc(100% - 40px) !important;
  }
  .load {
    min-height: 100px;
  }
  .bodyContent {
    /* border: 5px solid red; */
    height: 100%;
    /* min-height: fit-content; */
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
  }
`;
